/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type ListItemChatActivity_ChatActivity = {
    readonly _id: string;
    readonly patient: {
        readonly _id: string;
        readonly firstname: string | null;
        readonly lastname: string | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"AvatarNode_Node" | "TypographyChatActivityLastMessage_ChatActivity" | "TypographyChatActivityUpdatedAt_ChatActivity" | "AvatarChatActivityReassign_ChatActivity">;
    readonly " $refType": "ListItemChatActivity_ChatActivity";
};
export type ListItemChatActivity_ChatActivity$data = ListItemChatActivity_ChatActivity;
export type ListItemChatActivity_ChatActivity$key = {
    readonly " $data"?: ListItemChatActivity_ChatActivity$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"ListItemChatActivity_ChatActivity">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "includeAssignee"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ListItemChatActivity_ChatActivity",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Patient",
      "kind": "LinkedField",
      "name": "patient",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "firstname",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "lastname",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "AvatarNode_Node"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyChatActivityLastMessage_ChatActivity"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TypographyChatActivityUpdatedAt_ChatActivity"
    },
    {
      "condition": "includeAssignee",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "AvatarChatActivityReassign_ChatActivity"
        }
      ]
    }
  ],
  "type": "ChatActivity",
  "abstractKey": null
};
})();
(node as any).hash = '45b53ae4765eeba1dceefb546500ee4c';
export default node;
